export const breakPoints = {
  xs: 200,
  sm: 340,
  // => @media (min-width: 340px) { ... }

  md: 680,
  // => @media (min-width: 680px) { ... }

  lg: 724,
  // => @media (min-width: 724px) { ... }

  xl: 900,

  "2xl": 1080,
  // => @media (min-width: 1080px) { ... }

  "3xl": 1236,
};
